/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

{
  // People viewing this product random code
  document.addEventListener("DOMContentLoaded", function () {
    const viewerText = document.getElementById("product-viewer-text");
    if (!viewerText) return;

    const maxViewers = parseInt(viewerText.dataset.maxViewers, 10);
    let currentViewers = Math.floor(Math.random() * maxViewers * 0.6) + 1;

    const svgIcon = `
    <svg xmlns="http://www.w3.org/2000/svg" fill="#000000" width="20px" height="20px" viewBox="0 0 32 32" version="1.1" style="vertical-align: middle; margin-right: 5px;">
      <path d="M0 16q0.064 0.128 0.16 0.352t0.48 0.928 0.832 1.344 1.248 1.536 1.664 1.696 2.144 1.568 2.624 1.344 3.136 0.896 3.712 0.352 3.712-0.352 3.168-0.928 2.592-1.312 2.144-1.6 1.664-1.632 1.248-1.6 0.832-1.312 0.48-0.928l0.16-0.352q-0.032-0.128-0.16-0.352t-0.48-0.896-0.832-1.344-1.248-1.568-1.664-1.664-2.144-1.568-2.624-1.344-3.136-0.896-3.712-0.352-3.712 0.352-3.168 0.896-2.592 1.344-2.144 1.568-1.664 1.664-1.248 1.568-0.832 1.344-0.48 0.928zM10.016 16q0-2.464 1.728-4.224t4.256-1.76 4.256 1.76 1.76 4.224-1.76 4.256-4.256 1.76-4.256-1.76-1.728-4.256zM12 16q0 1.664 1.184 2.848t2.816 1.152 2.816-1.152 1.184-2.848-1.184-2.816-2.816-1.184-2.816 1.184l2.816 2.816h-4z"/>
    </svg>
  `;

    function updateViewers() {
      const change = Math.floor(Math.random() * 5) + 1;
      const direction = Math.random() < 0.5 ? -1 : 1;
      currentViewers = currentViewers + change * direction;
      if (currentViewers < 1) currentViewers = 1;
      if (currentViewers > maxViewers) currentViewers = maxViewers;
      viewerText.innerHTML = `${svgIcon}${currentViewers} People viewing this product`;
    }

    viewerText.innerHTML = `${svgIcon}${currentViewers} People viewing this product`;
    setInterval(updateViewers, 3000);
  });
}



// {
//   // cart drawer hide & show function
//   let custom_js_btn = document.querySelector('.custom_js-cart_close-btn');
//   let custom_cart_drawer = document.querySelector(".custom-cart-drawer");

//   let custom_js_wt_cart__trigger = document.querySelector(".custom_js_wt-cart__trigger");


//   custom_js_wt_cart__trigger.addEventListener("click", () => {
//     alert("custom_js_wt_cart__trigger click ");

//     custom_cart_drawer.classList.add("custom-js-cart-drawer");
//   });


//   custom_js_btn.addEventListener("click",()=>{

//     alert("custom_js_btn clicked ");
    
//     custom_cart_drawer.classList.remove("custom-js-cart-drawer");
//   })
// }